import { getZrmListingInfo, getZrmRentalsLead, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import {
  type ClickstreamEventParams,
  SEMANTIC_EVENT_NAME,
  TOPIC_TAG_TXT,
  TRIGGER_OBJECT,
  TRIGGER_SOURCE,
  TRIGGER_TYPE,
} from './globals';

const EVENT_TEMPLATE_ID = '628';

// https://dataportal.zillowgroup.net/event-registry/2452
export const SEND_MESSAGE_EVENT_TYPE_ID = '2452';
export const emitSendMessageEvent = ({ user, listing, triggerLocation, lead }: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: SEND_MESSAGE_EVENT_TYPE_ID,
      event_type_version_id: '3',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: TRIGGER_SOURCE.SendButton,
      trigger_object_nm: TRIGGER_OBJECT.MessageWindow,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReplyMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });

// https://dataportal.zillowgroup.net/event-registry/8432
export const emitSendDraftMessageEvent = ({ user, listing, triggerLocation, lead }: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: '8432',
      event_type_version_id: '3',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: TRIGGER_SOURCE.SendButton,
      trigger_object_nm: TRIGGER_OBJECT.MessageWindow,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ReplyMessage,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
